"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a, _b, _c;
Object.defineProperty(exports, "__esModule", { value: true });
exports.commonLabelStyles = exports.inputDefaultStyles = exports.getPaddings = exports.defaultAdornmentStyle = exports.disableDefaultStyles = exports.rootDefaultStyles = void 0;
var system_1 = require("../../system");
var utils_1 = require("../../utils");
var rootDefaultStyles = function (theme) {
    return (__assign(__assign({}, theme.mixins.typography.Body), { minHeight: 40, color: theme.schemes.colors.system.TextMain, position: 'relative', padding: '0 !important' }));
};
exports.rootDefaultStyles = rootDefaultStyles;
var disableDefaultStyles = function (theme) {
    return ({
        opacity: 0.6,
        pointerEvents: 'none',
        color: theme.schemes.colors.system.TextMain,
    });
};
exports.disableDefaultStyles = disableDefaultStyles;
exports.defaultAdornmentStyle = {
    adornedEnd: {
        paddingRight: 0,
    },
    adornedStart: {
        paddingLeft: 0,
    },
};
var inputPaddingLeft = (_a = {},
    _a[system_1.InputVariants.Line] = 0,
    _a.default = 10,
    _a);
var selectInputPaddingRight = (_b = {},
    _b[system_1.InputVariants.Frame] = 60,
    _b[system_1.InputVariants.Float] = 60,
    _b[system_1.InputVariants.Line] = 52,
    _b.default = 52,
    _b);
var getPaddings = function (_a) {
    var _b;
    var iconStart = _a.iconStart, disabled = _a.disabled, clearable = _a.clearable, variant = _a.variant, select = _a.select, multi = _a.multi;
    var paddingLeft = iconStart
        ? 34 - (variant === system_1.InputVariants.Line ? 5 : 0)
        : (_b = inputPaddingLeft[variant || system_1.InputVariants.Line]) !== null && _b !== void 0 ? _b : inputPaddingLeft.default;
    var paddingRight = disabled || clearable === false ? 10 : 36;
    var selectPaddingRight = multi
        ? 10
        : ((variant && selectInputPaddingRight[variant]) || selectInputPaddingRight.default) -
            (clearable === false ? 24 : 0);
    return "9px ".concat(select ? selectPaddingRight : paddingRight, "px 9px ").concat(paddingLeft, "px !important");
};
exports.getPaddings = getPaddings;
exports.inputDefaultStyles = __assign({ textOverflow: 'ellipsis', overflow: 'hidden', boxSizing: 'content-box !important' }, ((0, utils_1.isIE11)()
    ? {
        '&::-ms-clear': {
            display: 'none',
        },
    }
    : {}));
var labelMarginBottomMap = (_c = {},
    _c[system_1.InputVariants.Line] = 0,
    _c[system_1.InputVariants.Frame] = 2,
    _c[system_1.InputVariants.Float] = 2,
    _c);
var commonLabelStyles = function (theme, variant) { return (__assign(__assign({}, theme.mixins.typography.Caption), { color: "".concat(theme.schemes.colors.system.TextMinor, " !important"), marginBottom: labelMarginBottomMap[variant || system_1.InputVariants.Line] })); };
exports.commonLabelStyles = commonLabelStyles;
